import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction
} from 'react';

type ThemeEditorWidth = 0 | 300 | 900;

type ThemeEditorContextType = {
  setThemeEditorWidth: Dispatch<SetStateAction<ThemeEditorWidth>>;
  themeEditorWidth: ThemeEditorWidth;
};

const ThemeEditorContext = createContext<ThemeEditorContextType>(undefined);

const ThemeEditorProvider = ({ children }: { children: ReactNode }) => {
  const [themeEditorWidth, setThemeEditorWidth] =
    useState<ThemeEditorWidth>(300);

  return (
    <ThemeEditorContext.Provider
      value={{ setThemeEditorWidth, themeEditorWidth }}
    >
      {children}
    </ThemeEditorContext.Provider>
  );
};

const useThemeEditorContext = () => {
  const ctx = useContext(ThemeEditorContext);
  return ctx || { setThemeEditorWidth: () => {}, themeEditorWidth: 0 };
};

export { ThemeEditorProvider, useThemeEditorContext };
